import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { StateType } from "../../../../utils/types";
import {
  editOnboarding,
  getCourse,
  getDepartment,
  getLesson,
  getModule,
  getOnboardingById,
  getPosition,
  getQuizzie,
  getTask,
  getUserByRole,
} from "../../../../redux/educator/actions";
import {
  selectCourses,
  selectDepartments,
  selectLessons,
  selectModules,
  selectOnboarding,
  selectOnboardingsLoading,
  selectPositions,
  selectQuizzies,
  selectTasks,
  selectUsersByRole,
} from "../../../../redux/educator/selector";

const mapStateToProps = (state: StateType) => ({
  onboarding: selectOnboarding(state),
  modules: selectModules(state),
  courses: selectCourses(state),
  lessons: selectLessons(state),
  quizzies: selectQuizzies(state),
  tasks: selectTasks(state),
  departments: selectDepartments(state),
  positions: selectPositions(state),
  users: selectUsersByRole(state),
  loading: selectOnboardingsLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getOnboardingById,
      editOnboarding,
      getModule,
      getCourse,
      getLesson,
      getQuizzie,
      getTask,
      getDepartment,
      getPosition,
      getUserByRole,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
